import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ChipsItem, HeaderTitle, Icon, Label } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Pages/Casino/CasinoFilterContext';
import {
  deleteCasinoFilter,
  toggleCasinoFilterListItem,
} from 'components/Pages/Casino/useCasinoFilter';

const FilterItem = ({ changeFilter, name, selectedFilter }) => {
  const keyName = name.toLowerCase();
  const active = selectedFilter?.includes(name);

  const label = <Label message={keyName} />;

  const onClick = useCallback(() => {
    changeFilter(name);
  }, [changeFilter, name]);

  return <ChipsItem active={active} key={keyName} label={label} onClick={onClick} />;
};

const MultiFilterList = ({ filterField, filters, title }) => {
  const { filter, updateFilter } = useCasinoFilterState();
  const filterCount = filter[filterField]?.length || null;
  const selectedFilter = filter[filterField];

  const resetFilter = useCallback(() => {
    updateFilter({ providerNames: [] });
    deleteCasinoFilter(filterField);
  }, [filterField, updateFilter]);

  const changeFilter = useCallback(
    name => {
      if (filter.providerNames.includes(name)) {
        const newArr = filter.providerNames.filter(el => el !== name);
        updateFilter({ providerNames: newArr });
      } else {
        updateFilter({ providerNames: [...filter.providerNames, name] });
      }
      toggleCasinoFilterListItem(filterField, name);
    },
    [filter.providerNames, filterField, updateFilter],
  );

  return (
    <>
      <div className="title-wrapper with-button">
        <HeaderTitle className="sub-text block-medium" title={title}>
          <span className="header-title__name">{filterCount && `\u00A0(${filterCount})`}</span>
        </HeaderTitle>
        {filterCount && (
          <button className="clear-button btn text small" onClick={resetFilter} type="button">
            <Icon className="icon-container" name="trash" />
            <Label message="Clear" />
          </button>
        )}
      </div>
      <div className="chips-list chips-list-wrap">
        {filters?.map(({ name }) => (
          <FilterItem
            changeFilter={changeFilter}
            key={name}
            name={name}
            selectedFilter={selectedFilter}
          />
        ))}
      </div>
    </>
  );
};

MultiFilterList.propTypes = {
  filterField: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
};
export default MultiFilterList;
